import React, {createContext, useContext, useState} from "react";
import {getProducts} from "./crud/productCrud";

const ProductsUIContext = createContext();

export function useProductsUIContext() {
    return useContext(ProductsUIContext);
}

export function ProductsUIProvider({children}) {


    const [id, setId] = useState(0);
    const [product, setProduct] = useState(undefined);
    const [photos, setPhotos] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState({});

    const fetchData = (page, limit) => {
        getProducts(page, limit)
            .then((response) => {
                setData(response.data.data);
            });
    };

    const handleEdit = id => {
        setOpenEdit(true);
        setId(id);
    };

    const handleDelete = id => {
        setOpenDelete(true);
        setId(id);
    };

    const value = {
        photos,
        setPhotos,
        product,
        setProduct,
        openError,
        setOpenError,
        error,
        setError,
        openEdit,
        setOpenEdit,
        openDelete,
        setOpenDelete,
        id,
        setId,
        handleDelete,
        handleEdit,
        fetchData,
        data,
        setData,
    };

    return <ProductsUIContext.Provider value={value}>{children}</ProductsUIContext.Provider>;
}